<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Alan Horsfield is an established children’s writer. He is a past president of the NSW Children’s Book Council (CBC) and a former judge for the NSW Premiers (Children’s) Book Awards. His books have been included in Australian State Premiers’ school reading lists. Industry reviews have been positive. First published in 1996, he presently has over 35 works of fiction for younger readers and the YA market. He intends to stretch the imagination of readers. He has written/co-written over 140 educational texts and worked with UNSW educational assessment. Alan is a full member of SCBWI.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?30773dfc